import { Instagram, Mail, MessageCircle, Phone } from "lucide-react";
import { motion } from "framer-motion";

const LINKS = [
  { id: "social-instagram", href: "https://instagram.com/kazerani_coin", label: "اینستاگرام", Icon: Instagram, external: true },
  { id: "social-whatsapp", href: "https://wa.me/989122682823", label: "واتساپ", Icon: MessageCircle, external: true },
  { id: "social-email", href: "mailto:kazeranicoin@gmail.com", label: "ایمیل", Icon: Mail },
  { id: "social-phone", href: "tel:+982188977824", label: "تماس تلفنی", Icon: Phone },
];

export const SocialDock = () => (
  <motion.div
    data-testid="social-dock"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.4, duration: 0.8 }}
    className="glass fixed bottom-6 left-6 z-40 flex flex-col gap-2 rounded-2xl p-2"
  >
    {LINKS.map(({ id, href, label, Icon, external }) => (
      <a
        key={id}
        data-testid={id}
        href={href}
        title={label}
        aria-label={label}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        className="flex h-11 w-11 items-center justify-center rounded-xl text-amber-200/80 transition-all duration-300 hover:scale-110 hover:bg-amber-500 hover:text-black"
      >
        <Icon className="h-5 w-5" />
      </a>
    ))}
  </motion.div>
);
